import React from "react";
import styled from "styled-components";
import VisitorIcon from "../../img/visitor-badge.png";
import CertifiedIcon from "../../img/CertifiedPartners.jpg";
import PreferredIcon from "../../img/preferred-partner.jpg";
import ExclusiveIcon from "../../img/ExclusivePartners.jpg";
import { PartnerTypes } from "../../models/ITier";

interface IHasWidth {
  width: number;
}

const IconContainer = styled.div``;

const Icon = styled.img<IHasWidth>`
  ${props => `width: ${props.width}px;`}
`;

const Badge = (src: any, width: number) => () => (
  <IconContainer>
    <Icon width={width} src={src} />
  </IconContainer>
);

export default (type: PartnerTypes, width: number = 115) => {
  switch (type) {
    case PartnerTypes.exclusive:
      return Badge(ExclusiveIcon, width);
    case PartnerTypes.preferred:
      return Badge(PreferredIcon, width);
    case PartnerTypes.certified:
      return Badge(CertifiedIcon, width);
    case PartnerTypes.visitor:
    default:
      return Badge(VisitorIcon, width);
  }
};
